import axios from "axios";

export const getTrabajos = async (
  token,
  page = 1,
  limit = 10,
  type = "",
  filters = {},
) => {
  const params = new URLSearchParams({ page, limit });
  if (type) params.append("type", type);
  Object.entries(filters).forEach(([key, val]) => {
    if (val) params.append(key, val);
  });
  return await axios.get(
    `${process.env.REACT_APP_API}/get-trabajos?${params.toString()}`,
    {
      headers: {
        "x-auth-token": token,
      },
    },
  );
};

export const getTrabajoById = async (token, id) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/get-trabajo-by-id`,
    id,
    {
      headers: {
        "x-auth-token": token,
      },
    },
  );
};

export const getTrabajoByIdNave = async (token, id) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/get-trabajos-by-id-nave`,
    id,
    {
      headers: {
        "x-auth-token": token,
      },
    },
  );
};

export const createTrabajo = async (token, body) => {
  return await axios.post(`${process.env.REACT_APP_API}/create-trabajo`, body, {
    headers: {
      "x-auth-token": token,
    },
  });
};

export const updateTrabajo = async (token, body) => {
  return await axios.put(`${process.env.REACT_APP_API}/update-trabajo`, body, {
    headers: {
      "x-auth-token": token,
    },
  });
};
